// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__FKLTr","title":"BackImages_title__3tg3v","images":"BackImages_images__3rS6D"};